import styled from "@emotion/styled";

import {
  colors,
  customEvent,
  getCdnImageSrc,
  NextLink,
  VStack,
  GoiLogo,
  EventPathType,
  ColorIcon,
  HStack,
} from "goi_common";

interface Props {
  onClose: () => void;
  path: keyof typeof EventPathType;
}

const ParlorPromotion50Modal = ({ onClose, path }: Props) => {
  const handleClickCTA = () => {
    customEvent({
      newGtm: {
        path,
        trigger_and_target: "mdal_parlor50_CTA",
      },
    });
    onClose();
  };

  return (
    <div
      css={{
        backgroundColor: colors.warmGray100,
      }}
    >
      <VStack
        css={{
          padding: "34px 12px 17px",
          textAlign: "center",
        }}
        gap="6px"
      >
        <HStack justifyContent="center" alignItems="center" gap="8px">
          <GoiLogo size={20} />
          <ColorIcon name="icon-x-mono" color={colors.orange650} size={12} />
          <p className="subtitle_14_b">중앙U병원 장례식장</p>
        </HStack>

        <div className="brown650">
          <p className="subtitle_21_eb">특별 제휴 할인 프로모션</p>
        </div>
      </VStack>
      <Img
        src={getCdnImageSrc("promotion/parlor/parlor_promotion_modal.jpg")}
        alt="장례식장 시설 비용"
      />
      <VStack
        css={{
          padding: "20px 0 34px",
          alignItems: "center",
        }}
      >
        <NextLink href="/parlor/promotion/50/" onClick={handleClickCTA}>
          <button
            className="subtitle_14_sb white"
            css={{
              padding: "12px 28px",
              backgroundColor: colors.warmGray900,
              borderRadius: "12px",
            }}
          >
            자세히 알아보기
          </button>
        </NextLink>
      </VStack>
    </div>
  );
};

export default ParlorPromotion50Modal;

const Img = styled.img({
  width: "100%",
  height: "240px",
});
